module.exports = __webpack_public_path__ + "6105d25b8bb04a826ae9ccbe2d41f62b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/stay.mp3
 ** module id = 649
 ** module chunks = 0
 **/